import { createSelector } from '@reduxjs/toolkit'
import { IUnits } from './reducer'

const rootState = (state: IUnits) => state.units

export const getUnitsMaster = createSelector(
  rootState,
  (state) => state.unitsMaster
)

export const getUnitsIndividual = createSelector(
  rootState,
  (state) => state.unitsIndividual
)

export const getUnitsCancel = createSelector(
  rootState,
  (state) => state.unitsCancel
)
